import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ClientSearch from '../ClientSearch';
import translations from './translations';

const ClientFormSection = ({ onChange, scopes, value, showError }) => {
  const intl = useIntl();
  const clientLabel = intl.formatMessage(translations.fields.client.label);

  return (
    <Card style={{ marginBottom: 8 }}>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <ClientSearch
          name="client"
          label={clientLabel}
          scopes={scopes}
          onChange={onChange}
          value={value}
          error={showError}
          errorMessage={intl.formatMessage(
            {
              id: 'errors.validation.empty',
              defaultMessage: '{target} could not be empty',
              description: 'Validation message for the client search field',
            },
            { target: clientLabel },
          )}
        />
      </CardContent>
    </Card>
  );
};

ClientFormSection.propTypes = {
  onChange: PropTypes.func,
  scopes: PropTypes.array,
  showError: PropTypes.bool,
  value: PropTypes.object,
};

ClientFormSection.defaultProps = {
  onChange: undefined,
  scopes: ['odr:orders:write'],
  showError: false,
  value: undefined,
};

export default ClientFormSection;
